/**
 * Copyright (C) Smartlife 2021 The Smartlife Connet Project.
 *
 * Green Color Main button used accrossed the app
 *
 * Changes Since initial code
 *  1. Linting - Maduka Dilshan
 *
 * @file This file define the main Green Button
 * @author Dinuka Bandara
 * @since 1.0.0
 */
import React from 'react';
import PropsTypes from 'prop-types';
import Button from '@mui/material/Button';
import styles from './GreenButton.module.css';

type ComponentProps = {
  text?: string;
  children?: any;
  onClick?: () => void;
  disable?: boolean;
};

/**
 * Main Green color button component of the app
 * @callback onClickCB
 * @param {Object} props            component props
 * @param {String} props.text       Text to display inside the button
 * @param {String} props.children   Custom JSX.Element to render as child
 * @param {onClickCB} props.onClick Fires when user click the button
 * @param {Boolean} props.disabled  Flag that determine if the button is clickable or not
 *
 * @returns JSX.Element
 */
const GreenButton: React.FunctionComponent<ComponentProps> = ({
  text,
  children,
  onClick,
  disable,
}) => (
  <Button
    disabled={disable}
    className={!disable ? styles.btnBg : styles.btnDisabled}
    size="small"
    onClick={() => {
      if (!disable && onClick) {
        onClick();
      }
    }}
  >
    <div className={!disable ? styles.btnText : styles.btnDisabledText}>
      {text}
    </div>
    {children != null ? (
      <div className={styles.iconText}>{children}</div>
    ) : (
      <div />
    )}
  </Button>
);

GreenButton.propTypes = {
  text: PropsTypes.string,
  children: PropsTypes.oneOfType([
    PropsTypes.arrayOf(PropsTypes.node),
    PropsTypes.node,
  ]),
  onClick: PropsTypes.func,
  disable: PropsTypes.bool,
};

GreenButton.defaultProps = {
  text: '',
  children: null,
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  onClick: () => {},
  disable: false,
};

export default GreenButton;
